import { ICON_SIZE, ICON_STROKE } from "./index.jsx";
import { IconService } from "./service.js";

export function preloadIcon(
  icon,
  size = ICON_SIZE.SIZE_16,
  type = ICON_STROKE.THIN
) {
  if (icon) {
    IconService.getIcon(icon, size, type);
  }
}
